import imgCaja from '../../../assets/img/cursos/curso/curso.1.jpeg';
import imgManualidades from '../../../assets/img/cursos/curso/manualidades.jpeg';
import ofimatica from '../../../assets/img/cursos/curso/ofimatica.jpeg';
const informacionComunCursos = [
  {
    titulo: 'Duración',
    icono: '◷',
    texto: '3 modulos',
  },
  /*
 {
   titulo: 'Modalidad',
   icono: '▤',
   texto: '100% online',
 },
 
 {
   titulo: 'Jornadas',
   icono: '▦',
   elementos: [
     'Sábados de 08:00 a. m. a 12:00 m.',
     'Jornada nocturna: 06:00 p. m. a 09:00 p. m.',
     'Horarios flexibles según grupos programados',
   ],
 },
 {
   titulo: 'Requisitos',
   icono: '☑',
   elementos: [
     'Fotocopia del documento de identidad ampliado al 150%',
     'Mayor de 15 años',
     'Certificado de EPS o Sisbén activo',
   ],
 }, */
];

const informacionprogramasCursos = [
  {
    slug: 'caja-registradora-sistematizada',
    titulo: 'Caja Registradora Sistematizada',
    nombreCorto: 'Caja Registradora',
    imagen: imgCaja,
    conoceMas: 'El curso de Caja Registradora Sistematizada capacita a los participantes en el manejo eficiente de puntos de venta (POS), herramientas de facturación electrónica, arqueos de caja y atención al cliente. Un perfil altamente demandado en el sector comercial y empresarial.',
    informacion: informacionComunCursos,
  },
  {
    slug: 'manualidades-creativas',

    titulo: 'Manualidades Creativas',
    nombreCorto: 'Manualidades',
    imagen: imgManualidades,
    conoceMas: 'Explora tu talento artesanal y emprendedor con técnicas avanzadas de decoración, confección y diseño de arreglos creativos. Ideal para iniciar tu propio negocio o fortalecer tus habilidades artísticas.',
    informacion: informacionComunCursos,
  },
  {
    slug: 'ofimatica',

    titulo: 'Ofimatica Basica',
    nombreCorto: 'ofimatica',
    imagen: ofimatica,
    conoceMas: 'El mundo laboral y académico actual exige mucho más que buenas intenciones: exige agilidad, orden y confianza frente a la tecnología. En este curso de ofimática básica no solo aprenderás a usar Word, Excel y PowerPoint desde cero; descubrirás cómo transformar documentos sencillos en presentaciones profesionales, automatizar tus cálculos diarios y ganar la seguridad que necesitas para abrir puertas, optimizar tu tiempo y hacer que tu talento brille sin complicaciones. ¡Da el paso definitivo hacia tu crecimiento profesional!',
    informacion: informacionComunCursos,
  },
];

export default informacionprogramasCursos;
